var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center p-2"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"loader"}),_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }